export const endorsementIssues = [
  { value: "Bind Pending Signatures and/or Down Payment" },
  { value: "UW Declined" },
  { value: "CW Needs to Issue Policy Manually" },
  { value: "Major Violation by One or More Drivers" },
  { value: "MVR No Hit" },
  { value: "MVR Not Matching" },
  { value: "UW Review" },
  { value: "Ineligible Cargo" },
  { value: "Insured Needs to make payment on outstanding balance" },
  { value: "Incorrect VIN" },
  { value: "Other" }
];
